import { CurrentUser, useCurrentUserQuery } from './useCurrentUserQuery';

export function useCurrentUser(): {
  currentUser: CurrentUser;
  fetching: boolean;
  userHasTeamOfMany: boolean;
} {
  const { data, fetching } = useCurrentUserQuery();

  const userHasTeamOfMany = Boolean(
    data?.currentUser?.teams.find((team) => team.members.length > 1)
  );

  return {
    currentUser: data?.currentUser,
    fetching,
    userHasTeamOfMany,
  };
}
